import { ReactNode, useContext, useEffect, useState } from 'react';
import { LoaderContext, LoaderContextValue } from '../context/LoaderContext';
import { Spinner } from '../components/Spinner/Spinner';
import { ProgressLoader } from 'src/components/ProgressLoader/ProgressLoader';

export function useLoader(): LoaderContextValue {
  return useContext(LoaderContext)!;
}

export function LoaderProvider({ children }: { children: ReactNode }) {
  const [isVisible, setIsVisible] = useState(false);
  const [progress, setProgress] = useState(0);
  const [isProgress, setIsProgress] = useState(false);

  const updateProgress = (value: number) => {
    setProgress(value);
  };

  const show = (options?: { progress?: boolean }) => {
    setIsVisible(true);

    if (options && options.progress) {
      setIsProgress(options.progress);
    }
  };

  const hide = () => {
    setIsVisible(false);
    setIsProgress(false);
    setProgress(0);
  };

  const value: LoaderContextValue = { isVisible, isProgress, progress, show, hide, updateProgress };

  return <LoaderContext.Provider value={value}>{children}</LoaderContext.Provider>;
}

export const Loader = () => {
  const { isVisible, isProgress, progress } = useLoader();

  useEffect(() => {
    if (!isVisible) {
      document.body.style.removeProperty('pointer-events');
    }

    return () => {
      if (!isVisible) {
        document.body.style.removeProperty('pointer-events');
      }
    };
  }, [isVisible]);

  return isVisible ? (
    isProgress ? (
      <ProgressLoader value={progress} fullScreen={true} />
    ) : (
      <Spinner fullScreen={true} />
    )
  ) : null;
};
